import { isDeepEqual } from '@/server-data'
import { form } from '../formState'

export function useFormValuesUnchanged(): boolean {
  // Subscribe to all form fields to trigger re-renders on value changes.
  // The useFormField() calls themselves create the subscriptions - no need to reference the values.
  form.useFormField('name')
  form.useFormField('email')
  form.useFormField('new-password')
  form.useFormField('gpsDeviceId')
  form.useFormField('summarizeFutureMobileRoute')
  form.useFormField('mobileFutureDaysVisibility')
  form.useFormField('trackDriver')
  form.useFormField('barcodeAttachmentAllowed')

  const { api } = form.useFormMeta()

  // Deep comparison of current vs initial values
  return isDeepEqual(api.getValues(), api.getInitialValues())
}
